<template>
  <div class="solution-content">
    <div class="banner">
      <div class="solution-banner">
        <h2>AI互动课堂解决方案</h2>
        <p>
          面向中小学教学的线下课堂，以AI技术为核心，
          从内容生产、分发 和消费等方面全面提供完整的AI课堂解决方案，
          为孩子提供更优 质的教学内容，更受关注的课堂体验
        </p>
      </div>
    </div>
    <div id="solution-nav" :class="{'solution-nav':true,'fixed':barFixed}">
      <div class="mar-content">
        <ul>
          <li
            v-for="(item,index) in navLink"
            :key="index"
            @click="addLinkClass(index)"
          >
            <a :class="{ active:className==index }">{{ item.name }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="barFixed" class="seize" />
    <div id="solution0">
      <div class="outline-plan">
        <p class="column-title">方案概述</p>
        <div class="outline-box">
          <img src="../assets/img/solution2.png">
          <div class="outline-section outline-section1">
            <h2>AI互动课堂内容生产系统</h2>
            <p>
              面向AI课件生产者，结合AI技术和教研生产能力生产出高质量的AI课件，同时确保内容生产在线化和可视化
            </p>
          </div>
          <div class="outline-section outline-section2">
            <h2>AI互动课堂内容分发系统</h2>
            <p>
              系统可根据用户的下载请求或者用户的排班情况，智能下载对应的课件，同时根据班级内学生的姓名和主讲老师信息合成学生音频并分发
            </p>
          </div>
          <div class="outline-section outline-section3">
            <h2>AI课堂互动系统</h2>
            <p>
              在AI引擎的支持下，Phoenix系统能对教学过程进⾏基于情感、互动、知识传授的建模以及教学效果智能评测与反馈，
              让每个学⽣在课堂上都能得到更多的关注，获得更丰富的互动参与机会，收到更全面的个性化反馈
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="solution1">
      <div class="solve-problem">
        <p class="column-title">解决问题</p>
        <div class="mar-content solve-box flex">
          <div>
            <div class="number">1</div>
            <div class="circle">xzxx</div>
            <h2>零经验启动</h2>
            <p>没有办学经验，不懂教学运维</p>
          </div>
          <div>
            <div class="number">2</div>
            <div class="circle">xzxx</div>
            <h2>优秀师资短缺</h2>
            <p>教师资源匮乏，找不到好老师</p>
          </div>
          <div>
            <div class="number">3</div>
            <div class="circle">xzxx</div>
            <h2>市场竞争弱</h2>
            <p>品牌声量低，难与其他机构抗衡</p>
          </div>
        </div>
      </div>
    </div>
    <div id="solution2" :class="{'addPadding':addClass==2}">
      <div class="mar-content advantage">
        <p class="column-title">方案优势</p>
        <div class="advantage-box flex">
          <div>
            <img src="../assets/img/solution1_1.png">
            <h2 class="fontSize20">独创的AI课制作能力和整体解决方案</h2>
          </div>
          <div>
            <img src="../assets/img/solution1_2.png">
            <h2 class="fontSize20">多融合方案保障高分发成功率</h2>
          </div>
          <div>
            <img src="../assets/img/solution1_3.png">
            <h2 class="fontSize20">AI课件生产多样化、标准化、规模化</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
// import Component from 'vue-class-component';

export default ({
  data() {
    return {
      navLink: [
        { name: '方案概述' },
        { name: '解决问题' },
        { name: '方案优势' },
      ],
      className: 0,
      tabOffsetTop: 0,
      scrollTop: 0,
      barFixed: false,
      addClass: -1,
    };
  },
  mounted() {
    this.tabOffsetTop = document.querySelector('#solution-nav').offsetTop;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    addLinkClass(index) {
      this.className = index;
      this.addClass = -1;
      const returnEle = document.querySelector(`#solution${index}`);
      if (returnEle) {
        this.addClass = index;
        console.log(this.addClass);
        returnEle.scrollIntoView(true);
      }
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || document.scrollingElement.scrollTop || 0;
      if (this.scrollTop > this.tabOffsetTop) {
        this.barFixed = true;
      } else {
        this.barFixed = false;
      }
    },
  },
});

</script>

<style scoped lang="less">
.banner{
  .solution-banner{
    background:url(../assets/img/banner_solution.png);
    background-size:cover;
    height:100%;
    color:#fff;
    padding-left:16%;
    h2{
      font-size:4.0104vw;
      color:rgba(255,255,255,1);
      line-height:5.625vw;
      font-weight:600;
    }
    p{
      font-size:1.5625vw;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:2.6041vw;
      width:54%;
      margin-top:1.25vw;
      letter-spacing: 1px;
    }
  }
}
.solution-content{
  .solution-nav{
    padding-top:0.2604vw;
    border-bottom: 2px solid #4A45D1;
    &>div{
      display: flex;
      justify-content: center;
    }
    ul{
      display: flex;
      justify-content: space-between;
      width:68%;
      height:4.6875vw;
      li{
        position: relative;
        line-height:4.6875vw;
        a{
          border:0;
          padding:0;
          border-radius: 0;
          font-size:18px;
          color:rgba(51,51,51,1);
          line-height:1.3021vw;
          &::after{
            content: '';
            position: absolute;
            bottom: -0.5729vw;
            left: 50%;
            width: 1.04167vw;
            height: 1.04167vw;
            border-bottom: 2px solid #4A45D1;
            border-left: 2px solid #4A45D1;
            border-right: 0;
            border-top: 0;
            background: #fff;
            -webkit-transform: translateX(-50%) rotate(-45deg);
            transform: translateX(-50%) rotate(-45deg);
            text-indent:-9999px;
            display:none;
          }
        }
        a:hover,.active{
          color:#4A45D1;
          &::after{
            display:block;
          }
        }
      }
    }
  }
  .solve-problem{
    background:url(../assets/img/solution4.png) no-repeat center bottom;
    background-size:contain;
    padding-top:9.375vw;
    padding-bottom:4.6875vw;
    .solve-box{
      margin-top:8.3333vw;
      >div{
        width:20.8333vw;
        height:13.5416vw;
        border-radius: 10px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(218,218,218,1);
        position:relative;
        padding-top:4.53125vw;
        text-align: center;
        .circle{
          width:6.25vw;
          height:6.25vw;
          border:1px solid rgba(218,218,218,1);
          border-radius:50%;
          position: absolute;
          left:50%;
          top:-50%;
          transform: translate(-50%,50%);
          background:#fff;
          z-index:10;
          &::after{
            content: '';
            width:6.3541vw;
            height:3.4770vw;
            background:#fff;
            position:absolute;
            top:-1px;
            left:-1px;
          }
        }
        .number{
          position: absolute;
          left:50%;
          top:-3.9583vw;
          transform: translate(-50%,0);
          z-index:11;
          width:5.46875vw;
          height:5.46875vw;
          border-radius: 50%;
          font-size:2.7083vw;
          font-family:PangMenZhengDao;
          color:rgba(255,255,255,1);
          line-height:3.0729vw;
          display: flex;
          justify-content: center;
          align-items: center;
          background:linear-gradient(198deg,rgba(66,154,255,1) 0%,rgba(77,33,182,1) 100%,rgba(97,35,245,1) 100%);
        }
        h2{
          font-size:1.302vw;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:1.875vw;
          &:after{
            content: '';
            display: block;
            width:1.8229vw;
            height:0.1562vw;
            background:linear-gradient(198deg,rgba(66,154,255,1) 0%,rgba(77,33,182,1) 100%,rgba(97,35,245,1) 100%);
            box-shadow:0px 3px 23px 0px rgba(218,218,218,0.5);
            border-radius:1px;
            margin:0.2604vw auto 0;
          }
        }
        p{
          font-size:0.9375vw;
          color:rgba(102,102,102,1);
          line-height:1.30208vw;
          margin-top:1.1458vw;
        }
        &:hover{
          box-shadow:0px 3px 20px 0px rgba(182,182,182,0.5);
          .number{
            box-shadow:0px 4px 7px 0px rgba(181,172,248,1);
          }
          .circle{
            box-shadow:0px 4px 7px 0px rgba(181,172,248,1) inset;
          }
        }
      }
    }
  }
  .advantage{
    padding-top:4.6875vw;
    padding-bottom: 9.375vw;
    .advantage-box{
      justify-content: space-around;
      margin-top:4.6875vw;
      >div{
        text-align: center;
        img{
          width:9.375vw;
          height:9.375vw;
        }
        h2{
          margin-top:2.0833vw;
        }
      }
    }
  }
  .outline-plan{
    padding-top:7.7916vw;
    .outline-box{
      position: relative;
      width:66%;
      text-align: center;
      margin:0 auto;
       margin-top:4.7916vw;
      img{
        width:100%;
      }
      .outline-section{
        border-radius: 10px;
        background:#9164ff;
        width:14.2708vw;
        position:absolute;
        color:#fff;
        top:0;
        left:0;
        padding:0.9375vw;
        &::after{
          content: '';
          display: block;
          border-top: 1.5625vw solid #9164ff;
          border-left: 1.5625vw solid transparent;
          position:absolute;
          bottom:-1.4625vw;
          right:0.5208vw;
          width: 0;
          height: 0;
        }
        h2{
          font-size:0.9375vw;
        }
        p{
          font-size:0.7291vw;
          margin-top:0.5208vw;
          text-align: left;
        }
      }
      .outline-section2{
        width:14.1666vw;
        right:0;
        left:auto;
        top:2.1083vw;
        &::after{
          border-top: 1.5625vw solid #9164ff;
          border-right: 1.5625vw solid transparent;
          border-left:0;
          position:absolute;
          left:1.5625vw;
          right:auto;
        }
      }
      .outline-section3{
        left:41.7916vw;
        top:23.9583vw;
        &::after{
          border-top: 1.5625vw solid #9164ff;
          border-left: 1.5625vw solid transparent;
          position:absolute;
          bottom:auto;
          left:-1.4625vw;
          right:auto;
          top:.9375vw;
        }
      }
    }
    img{
      width:66%;
    }
  }
  .fixed{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:#fff;
    z-index:100;
  }
  #solution2:target{
    padding-top:5.1354vw;
  }
  .addPadding{
    padding-top:4.9479vw;
  }
  .seize{
    height:4.9479vw;
  }
}
</style>
